
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from 'react';
import { HiArrowLeft } from "react-icons/hi2";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ONBOARDING_API_ENDPOINT } from "../config/url.config";
import { navigateToSessionExpired } from "../utils/sessionExpired";
import { documentsWasUpdatedByUser } from "../utils/updatedByUser";
import { getAuthHeader } from "../utils/superFetch";

import { Button, Navbar } from 'flowbite-react';

const PersonalDetails = (props) => {
  const [personalDetails, setPersonalDetails] = useState({})
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));
  let [validation, setValidation] = useState({ show: false , message: "", class:""});
  let [userUpdatedData, setUserUpdatedData] = useState(false);

  useEffect(()=>{
    for(let requiredItems of props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems) {
      if (requiredItems.value !== "" && requiredItems.itemName === 'dateOfBirth') {
        setPersonalDetails(personalDetails => ({...personalDetails, dateOfBirth: requiredItems.value.substring(0,10)}))
      }
      if (requiredItems.value !== "" && requiredItems.itemName === 'nric') {
        setPersonalDetails(personalDetails => ({...personalDetails, nric: requiredItems.value}))
      }
      if (requiredItems.value !== "" && requiredItems.itemName === 'postalCode') {
        setPersonalDetails(personalDetails => ({...personalDetails, postalCode: requiredItems.value}))
      }
      if (requiredItems.value !== "" && requiredItems.itemName === 'address') {
        setPersonalDetails(personalDetails => ({...personalDetails, address: requiredItems.value}))
      }
      if (requiredItems.value !== "" && requiredItems.itemName === 'block') {
        setPersonalDetails(personalDetails => ({...personalDetails, block: requiredItems.value}))
      }
      if (requiredItems.value !== "" && requiredItems.itemName === 'floor') {
        setPersonalDetails(personalDetails => ({...personalDetails, floor: requiredItems.value}))
      }
      if (requiredItems.value !== "" && requiredItems.itemName === 'unit') {
        setPersonalDetails(personalDetails => ({...personalDetails, unit: requiredItems.value}))
      }
    }
    setUserUpdatedData(false)
  },[])

  const handlePersonalDetailsChange = (field, value) => {
    setPersonalDetails(personalDetails=>({...personalDetails , [`${field}`]:value}))
  }

  const handlePersonalDataUpload = async () => {
    if (userUpdatedData === false) {
      props.setOpenUploadDocument({openDocument : false , documentType : ""})
      return
    }
    if (moment().diff(moment(personalDetails.dateOfBirth, 'YYYY-MM-DD'), 'years') < 18 || personalDetails.dateOfBirth === "") {
      setValidation({ show: true , message: "Provide valid date of birth. User must be 18 years or older to have access to this service", class:"error-msg"})
      return 
    }
    if (personalDetails.nric && !personalDetails.nric.toUpperCase().match(/^[STFGstfg]\d{7}[A-Za-z]$/)) {
      setValidation({ show: true , message: "Provide valid NRIC details!", class:"error-msg"})
      return
    }
    if (!personalDetails.postalCode || personalDetails.postalCode.length !== 6) {
      setValidation({ show: true , message: "Provide valid postal code!", class:"error-msg"})
      return
    }
    if (!personalDetails.address) {
      setValidation({ show: true , message: "Provide valid address of residence", class:"error-msg"})
      return
    }
    if (!personalDetails.block) {
      setValidation({ show: true , message: "Provide valid Block of residence", class:"error-msg"})
      return
    }
    if (!personalDetails.floor) {
      setValidation({ show: true , message: "Provide valid floor of residence", class:"error-msg"})
      return
    }
    if (!personalDetails.unit) {
      setValidation({ show: true , message: "Provide valid Unit number of residence", class:"error-msg"})
      return
    }
    setValidation({ show: false , message: "", class:""})
    let dataBody = {
      item : "personalDetails" ,
      requiredItems: [
        {
          itemName: 'dateOfBirth' ,
          value: personalDetails.dateOfBirth
        },
        {
          itemName: 'nric' ,
          value: personalDetails.nric.toUpperCase()
        },
        {
          itemName: 'postalCode' ,
          value: personalDetails.postalCode
        },
        {
          itemName: 'address' ,
          value: personalDetails.address
        },
        {
          itemName: 'block' ,
          value: personalDetails.block
        },
        {
          itemName: 'floor' ,
          value: personalDetails.floor
        },
        {
          itemName: 'unit' ,
          value: personalDetails.unit
        },
      ]
    }
    const config = {
      headers: { "content-type": "application/json", "upload-document": false , ...getAuthHeader() },
    };
     try {
      const endpoint = `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${selectedProfileType.profileId}`;
      const res = await axios.post(endpoint, dataBody, config);
      if (res.status) {
        let tmpMemberData = {...props.memberRequirement}
        for (let i =0 ; i < tmpMemberData.requiredDocuments[props.itemIndex].requiredItems.length ;i++) {
          if (tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].itemName in personalDetails) {
            if(tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].status === 2 || 
              tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].value !== '') {
              documentsWasUpdatedByUser(`${tmpMemberData.requiredDocuments[props.itemIndex].item}`)
            }

            tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].value = personalDetails[`${tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].itemName}`]
            tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i].uploadedTime = moment.unix()

            
          } 
        }
          props.setMemberRequirement(tmpMemberData)
          props.setOpenUploadDocument({openDocument : false , documentType : ""})
      
      }
      return
    } catch (err) {
     if (err.response && err.response.status === 400) {
      setValidation({ show: true , message: err.response.data.error.title, class:"error-msg"})
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      return
     }
     navigateToSessionExpired(navigate, {
      reason: "personal_details_submit_failed",
      source: "handlePersonalDataUpload",
     component: "PersonalDetails",
      status: err?.response?.status,
      message: err?.message,
     })
    }
  }

  const validationOnChange = () => {
    if (validation.show && (moment().diff(moment(personalDetails.dateOfBirth, 'YYYY-MM-DD'), 'years') < 18 || personalDetails.dateOfBirth === "")) {
      setValidation({ show: true , message: "Provide valid date of birth. User must be 18 years or older to have access to this service", class:"error-msg"})
      return 
    }
    else if (validation.show && !personalDetails.nric.match(/^[STFG]\d{7}[A-Z]$/)) {
      setValidation({ show: true , message: "Provide valid NRIC details!", class:"error-msg"})
      return
    }
    else if (validation.show && !personalDetails.postalCode) {
      setValidation({ show: true , message: "Provide valid postal code!", class:"error-msg"})
      return
    }
    else if (validation.show && !personalDetails.address) {
      setValidation({ show: true , message: "Provide valid address of residence", class:"error-msg"})
      return
    }
    else if (validation.show && !personalDetails.block) {
      setValidation({ show: true , message: "Provide valid Block of residence", class:"error-msg"})
      return
    }
    else if (validation.show && !personalDetails.floor) {
      setValidation({ show: true , message: "Provide valid floor of residence", class:"error-msg"})
      return
    }
    else if (validation.show && !personalDetails.unit) {
      setValidation({ show: true , message: "Provide valid Unit number of residence", class:"error-msg"})
      return
    } else {
      setValidation({ show: false , message: '', class:""})
    }
  }

  return (
    <>
      <Navbar
        fluid={true}
        rounded={true}
        className='shadow mb-3' style={{position:'fixed', width:'100%', top:'0'}}>
          
            <Navbar.Brand onClick={()=>{props.setOpenUploadDocument({openDocument : false , documentType : ""})}}>
             
                  <HiArrowLeft className='h-10 w-5 ml-2' />
             
            </Navbar.Brand>
          
        
      </Navbar>
    <div className='p-6 max-w-md m-auto' style={{paddingTop:'80px'}}>
        <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
           Personal Details
        </h5>
        <p className='mb-8 text-gray-600'>Fill in personal details as in your ID for bank verification. This ensures prompt transfer of earnings to your bank account.</p>

        { validation.show &&
                  
                  <div className={validation.class}>
                      <span >{validation.message}</span>
                  </div>
              
              }

      <div className="hidden sm:block" aria-hidden="true">
        <div className="py-5">
          <div className="border-t border-gray-200" />
        </div>
      </div>


            <form action="#" method="POST">
              <div className="overflow-hidden sm:rounded-md">
                <div className="bg-white py-5 ">
                  <div className="grid grid-cols-6 gap-6">
                    

                    <div className="col-span-6">
                      <label htmlFor="street-address" className="block text-sm font-medium text-gray-700">
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        name="street-address"
                        id="street-address"
                        autoComplete="street-address"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        onChange={(e)=>{ setUserUpdatedData(()=> true); handlePersonalDetailsChange('dateOfBirth',e.target.value); validationOnChange();}}
                        value={personalDetails.dateOfBirth}
                      />
                    </div>

                    <div className="col-span-6">
                      <label htmlFor="street-address" className="block text-sm font-medium text-gray-700">
                        NRIC
                      </label>
                      <input
                        type="text"
                        name="street-address"
                        id="street-address"
                        autoComplete="street-address"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        onChange={(e)=>{setUserUpdatedData(()=> true); handlePersonalDetailsChange('nric',e.target.value.toUpperCase()); validationOnChange();}}
                        value={personalDetails.nric}
                      />
                    </div>

                    <div className="col-span-6">
                      <label htmlFor="street-address" className="block text-sm font-medium text-gray-700">
                        Postal Code
                      </label>
                      <input
                        type="number"
                        name="street-address"
                        id="street-address"
                        maxlength="9"
                        autoComplete="street-address"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        onChange={(e)=>{setUserUpdatedData(()=> true); handlePersonalDetailsChange('postalCode',e.target.value); validationOnChange();}}
                        value={personalDetails.postalCode}
                      />
                    </div>

                    <div className="col-span-6">
                      <label htmlFor="street-address" className="block text-sm font-medium text-gray-700">
                        Address
                      </label>
                      <input
                        type="text"
                        name="street-address"
                        id="street-address"
                        autoComplete="street-address"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        style={{height: '70px'}}
                        onChange={(e)=>{setUserUpdatedData(()=> true);handlePersonalDetailsChange('address',e.target.value); validationOnChange();}}
                        value={personalDetails.address}
                      />
                    </div>


                    {/* Three column in same */}
                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                      <label htmlFor="city" className="block text-sm font-medium text-gray-700">
                        Block
                      </label>
                      <input
                        type="text"
                        name="city"
                        id="city"
                        autoComplete="address-level2"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        onChange={(e)=>{setUserUpdatedData(()=> true); handlePersonalDetailsChange('block',e.target.value); validationOnChange();}}
                        value={personalDetails.block}
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                      <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                        Floor
                      </label>
                      <input
                        type="text"
                        name="region"
                        id="region"
                        autoComplete="address-level1"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        onChange={(e)=>{setUserUpdatedData(()=> true); handlePersonalDetailsChange('floor',e.target.value); validationOnChange();}}
                        value={personalDetails.floor}
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                      <label htmlFor="postal-code" className="block text-sm font-medium text-gray-700">
                        Unit
                      </label>
                      <input
                        type="text"
                        name="postal-code"
                        id="postal-code"
                        autoComplete="postal-code"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        onChange={(e)=>{setUserUpdatedData(()=> true); handlePersonalDetailsChange('unit',e.target.value); validationOnChange();}}
                        value={personalDetails.unit}
                      />
                    </div>
                  </div>
                </div>
                <Button className='w-full mt-5' pill={true} disabled={false} onClick={()=>{handlePersonalDataUpload()}}>
                    Save
                  </Button>
              </div>
            </form>
          

      </div>
    
    </>
  )
}

export default PersonalDetails;